import { useCallback, useEffect } from "react";
import { useNichesStore } from "@/common/store/storeNiches";
import { apiNiches } from "../services";
import { useFetch } from "./useFetch";

interface IUseCachedNiche {
  niche: string;
}

export const useCachedNiche = ({ niche }: IUseCachedNiche) => {
  const currentNiche = useNichesStore(state => state.getNiche(niche));
  const updateNiches = useNichesStore(state => state.updateNiches);

  const fetchNiche = useCallback(() => apiNiches.getNiche(niche), [niche]);

  const { isLoading, error, data } = useFetch(fetchNiche, !currentNiche);

  useEffect(() => {
    if (!error && data) {
      updateNiches([data]);
    }
  }, [error, data, updateNiches]);

  return {
    niche: currentNiche,
    isLoading,
    error,
  };
};
